import React, { useEffect, useState } from 'react';
import { Card, Row, Col, Modal, Button, Tooltip } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import OrderList from '../components/Order/OrderList';
import OrderForm from '../components/Order/OrderForm';
import { Order } from '../types/order';
import { OrderProvider, useOrder } from '../store/orderContext';
import { useTranslation } from 'react-i18next';

const OrderPageContent: React.FC = () => {
  const [editOrder, setEditOrder] = useState<Order | undefined>();
  const [modalVisible, setModalVisible] = useState(false);
  const { addOrder, updateOrder, fetchOrdersByStatus } = useOrder();
  const { t } = useTranslation();

  useEffect(() => {
    fetchOrdersByStatus('processing');
  }, []);

  const handleSubmit = (order: Order) => {
    order.id ? updateOrder(order) : addOrder(order);
    setModalVisible(false);
    setEditOrder(undefined);
  };

  const handleEdit = (order: Order) => {
    setEditOrder(order);
    setModalVisible(true);
  };

  return (
    <>
      <Row gutter={16}>
        <Col span={24}>
          <Card
            title={t('order_list')}
            extra={
              <Tooltip title={t('add_new_order')}>
                <Button
                  type="primary"
                  shape="round"
                  size="large"
                  icon={<PlusOutlined />}
                  style={{
                    background: '#1677ff',
                    borderColor: '#1677ff',
                    boxShadow: '0 2px 6px #1677ff22',
                    fontWeight: 500,
                    display: 'flex',
                    alignItems: 'center'
                  }}
                  onClick={() => {
                    setEditOrder(undefined); // clear previous edit
                    setModalVisible(true);
                  }}
                >
                  {t('add_new_order')}
                </Button>
              </Tooltip>
            }
          >
            <OrderList onEdit={handleEdit} />
          </Card>
        </Col>
      </Row>

      <Modal
        title={editOrder ? t('edit_order') : t('add_new_order')}
        open={modalVisible}
        onCancel={() => {
          setModalVisible(false);
          setEditOrder(undefined);
        }}
        footer={null}
        width={900}
        destroyOnClose
      >
        <OrderForm
          editOrder={editOrder}
          onSubmit={handleSubmit}
          onFinishEdit={() => {
            setModalVisible(false);
            setEditOrder(undefined);
          }}
        />
      </Modal>
    </>
  );
};

const OrdersPage: React.FC = () => (
  <OrderProvider>
    <OrderPageContent />
  </OrderProvider>
);

export default OrdersPage;
